import { render, staticRenderFns } from "./CreditWallet.vue?vue&type=template&id=088b9594&"
import script from "./CreditWallet.vue?vue&type=script&lang=js&"
export * from "./CreditWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreditWallet.vue"
export default component.exports